import React, { FC } from "react";
import { Box, Stack } from "@mui/material";
import AlbumItem from "@components/AlbumItem";
import { useGetAlbumsQuery } from "@store/albumApi";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import Loader from "@components/Loader/Loader";
import { Mode } from "@store/homeSlice";

const Albums: FC = () => {
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const { data: albums, isLoading } = useGetAlbumsQuery(
    { patientId: selectedPatientId! },
    { skip: !selectedPatientId },
  );
  return (
    <>
      {!albums?.data || isLoading ? (
        <Loader />
      ) : (
        <Stack
          flexDirection="row"
          flexWrap="wrap"
          gap="24px"
          justifyContent={{ xs: "center", sm: "flex-start" }}
        >
          {albums.data.map((album) => (
            <Box width={{ xs: "100%", sm: "290px" }} key={album.id}>
              <AlbumItem album={album} mode={Mode.Patient} />
            </Box>
          ))}
        </Stack>
      )}
    </>
  );
};

export default Albums;
